import axios, { AxiosInstance, AxiosResponse, AxiosError } from 'axios';
import { showToastError } from 'utils/toasts';

const api: AxiosInstance = axios.create({
  baseURL: process.env.REACT_APP_BACKEND_API_URL + '/api',
});

api.interceptors.response.use(

  (response: AxiosResponse) => response,

  (error: AxiosError) => {
   
    if (error.response?.status === 500) {
      // Tratamento específico para erro 500 (Internal Server Error)

      console.error('Erro interno no servidor:', error?.message);
      showToastError('Algo deu errado. Tente novamente mais tarde.');

      throw new Error('Erro interno no servidor');
    }
    
    throw error; // Outros erros serão tratados no ponto de uso
  }
);

export default api;